module.exports = __webpack_public_path__ + "img/history-black-24-dp.2b78e00d.svg";